import React from 'react';
import { useTranslation } from 'react-i18next';
import { LabeledSelect } from '../LabeledSelect';
import { getProgramDesignationLabels } from './utils/getProgramDesignationLabels';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The labelled program designations select component
 */
export const ProgramDesignationsSelect = ({
  value,
  options,
  dispatch,
  blockId,
  shouldShowErrorState
}) => {
  const {
    t
  } = useTranslation('blocks.impact');
  const programDesignationIds = options.map(option => option.id);
  const programDesignationLabels = getProgramDesignationLabels(options);
  return /*#__PURE__*/_jsx(LabeledSelect, {
    label: t('ProgramDesignationsSelect.labeledSelect.label', 'Program designation'),
    value: value?.id,
    options: programDesignationIds,
    optionDisplayStrings: programDesignationLabels,
    onChange: e => {
      e.preventDefault();
      const id = Number(e.target.value);
      const programDesignation = options.find(option => option.id === id);
      if (programDesignation) {
        dispatch({
          type: 'SELECT_PROGRAM_DESIGNATION',
          programDesignation
        });
      }
    },
    shouldShowErrorState: shouldShowErrorState,
    placeholderOptionText: t('ProgramDesignationsSelect.labeledSelect.placeholder', 'Select a program'),
    onBlur: () => dispatch({
      type: 'TOUCH_ERRORABLE_INPUT',
      input: 'programDesignationSelect'
    }),
    "data-id": "cp-impact-program-designation",
    name: "program-designation",
    "aria-invalid": shouldShowErrorState,
    "aria-errormessage": `${blockId}-error-message`
  });
};